<template>
  <div class="bg-container page">
    <div class="bg-wrapper">
      <div class="login">
        <van-nav-bar class="nav-bar">
          <template #right>
            <div class="language" @click="$router.push('/language')">
              <img src="/img/vn_vn.d0c3f8f6.png" alt="ko" />
            </div>
          </template>
        </van-nav-bar>
        <div class="wrapper">
          <div class="logo-container">
            <div class="logo-wrapper">
              <img class="logo-img" :src="logoSrc" alt="logo" />
            </div>
          </div>
          <div class="title">{{ siteName }}</div>
          <div class="loginForm">
            <van-field
              v-model="username"
              clearable
              input-align="center"
              class="input"
              :placeholder="$t('auth.username_place')"
            />
            <van-field
              v-model="password"
              :type="passwordType"
              input-align="center"
              class="input"
              :placeholder="$t('auth.pwd_place')"
            >
              <template slot="right-icon">
                <van-icon
                  :name="passwordType === 'password' ? 'closed-eye' : 'eye-o'"
                  @click="switchPasswordType"
                />
              </template>
            </van-field>
            <div class="reset-text" @click="noPsw">
              <span>{{ $t("auth.forgetpwd") }}?</span>
            </div>
            <van-button
              class="login-btn"
              type="primary"
              size="normal"
              :disabled="isDisabled"
              @click="doLogin()"
              >{{ $t("auth.login") }}</van-button
            >
            <van-button
              class="login-btn register-btn"
              type="primary"
              size="normal"
              @click="toRegister()"
              >{{ $t("auth.no_account") }}</van-button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { resolveAssetUrl } from "../../http";
export default {
  data() {
    return {
      username: "",
      password: "",
      passwordType: "password",
      isDisabled: false,
      logoSrc: "",
    };
  },
  computed: {
    siteName() {
      const info = this.$store.getters.getBaseInfo || {};
      return info.name || "";
    },
  },
  beforeMount() {
    localStorage.setItem("lang", "kr");
    this.$i18n.locale = "kr";
  },
  mounted() {
    this.getBaseInfo();
  },
  methods: {
    getBaseInfo() {
      this.$http({
        method: "get",
        url: "base_info",
      })
        .then((res) => {
          if (res && res.code === 200 && res.data) {
            this.$store.commit("setBaseInfoValue", res.data);
            if (res.data.ico) {
              this.logoSrc = resolveAssetUrl(res.data.ico);
            }
          }
        })
        .catch(() => {
          /* ignore */
        });
    },
    switchPasswordType() {
      this.passwordType =
        this.passwordType === "password" ? "text" : "password";
    },
    back() {
      this.$router.push("/");
    },
    noPsw() {
      this.$toast(this.$t("auth.customerService") || "고객센터에 문의하세요");
    },
    toRegister() {
      this.$router.push("Register");
    },
    doLogin() {
      if (!this.username) {
        this.$toast(this.$t("auth.username_place"));
        return false;
      }
      if (!this.password) {
        this.$toast(this.$t("auth.pwd_place"));
        return false;
      }
      this.isDisabled = true;
      this.$http({
        url: "member_login",
        method: "get",
        data: {
          username: this.username,
          password: this.password,
        },
      })
        .then((res) => {
          this.isDisabled = false;
          if (res.code === 200) {
            this.$toast.success(res.msg);
            localStorage.setItem("token", res.data.id || res.data);
            this.$router.push("Mine");
          } else {
            this.$toast(res.msg);
          }
        })
        .catch(() => {
          this.isDisabled = false;
        });
    },
  },
  created() {
    if (localStorage.getItem("token")) {
      return window.history.back();
    }
  },
};
</script>

<style lang="less" scoped>
/* 1:1 from dhtkg.vip login */
.page {
  position: absolute !important;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
.bg-container {
  position: relative;
  bottom: 0;
  background: linear-gradient(-45deg, #1a1a1a, #000000);
  z-index: 2;
  min-height: 100vh;
  height: 100%;
}
.bg-container .bg-wrapper {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(hsla(0, 0%, 0%, 0), #000000);
}
.login {
  height: 100%;
}
.bg-container .bg-wrapper .login .nav-bar {
  background: transparent !important;
  border-bottom: none !important;
}
.language {
  position: absolute;
  top: 0.533vw;
  right: 0;
  height: 10.667vw;
  img {
    height: 100%;
  }
}
.login .wrapper {
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
.logo-container {
  margin: 0 auto;
  width: 45%;
}
.logo-container .logo-wrapper {
  position: relative;
  padding-bottom: 62.5%;
}
.logo-container .logo-wrapper .logo-img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
  opacity: 0.8;
}
.login .wrapper .title {
  line-height: 13.333vw;
  text-align: center;
  font-size: 8vw;
  font-weight: 700;
  color: #fff;
  letter-spacing: 0.667vw;
}
.login .wrapper .loginForm {
  padding: 8vw;
}
.login .wrapper .loginForm .input {
  padding: 1.333vw 2.667vw;
  margin-top: 5.333vw;
  border-radius: 6.667vw;
  text-align: center;
  line-height: 10.667vw;
  font-size: 4vw;
  color: #4e4e4e;
  background: #141414 !important;
  border: none;
}
::v-deep .van-field__control {
  color: #4e4e4e !important;
}
::v-deep .van-cell::after {
  display: none;
}
::v-deep .van-field__right-icon .van-icon {
  font-size: 5vw;
  color: #999;
}
.login .wrapper .loginForm .reset-text {
  margin: 4vw 2vw;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.login .wrapper .loginForm .reset-text span {
  color: #fff;
  font-size: 3.333vw;
  font-weight: 500;
  line-height: 2vw;
}
.login .wrapper .loginForm .login-btn {
  margin-top: 4vw;
  width: 100%;
  height: 13.333vw;
  border-radius: 6.667vw;
  color: #fff !important;
  background-color: #c9a84c !important;
  font-size: 4vw;
  font-weight: bolder;
  border: none;
  box-shadow: 0 0 0.533vw #fff;
}
.login .wrapper .loginForm .register-btn {
  background: #c9a84c !important;
}
</style>
